import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass:
        "lpu-set-card d-flex flex-column flex-sm-row align-center align-sm-start ga-4 pa-4 pa-sm-6 rounded-xl bg-gray-0 w-100 min-w-0",
      attrs: { "data-qa": "analyses_lpu_set_card" },
    },
    [
      _c(
        "div",
        { staticClass: "lpu-set-card__logo-col" },
        [
          _setup.ff_update_lpu_logo
            ? _c(_setup.LpuLogoPicture, {
                attrs: {
                  "img-class": "lpu-set-card__logo lpu-set-card__order-logo",
                  "data-qa": "analyses_lpu_set_card_logo",
                  contain: "",
                  files: _vm.logoFiles,
                  alt: _vm.logoAlt || `Логотип ${_vm.name}`,
                },
              })
            : _c(VImg, {
                staticClass: "lpu-set-card__logo lpu-set-card__order-logo",
                attrs: {
                  "data-qa": "analyses_lpu_set_card_logo",
                  src: _vm.logoUrl,
                  alt: _vm.logoAlt || `Логотип ${_vm.name}`,
                  contain: "",
                },
              }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "lpu-set-card__order-meta d-flex flex-column align-center ga-4",
            },
            [
              _c(_setup.LpuCardRating, {
                attrs: {
                  rating: _vm.rating,
                  "reviews-count": _vm.reviewsCount,
                  "reviews-href": _vm.reviewsHref,
                  "hide-rating": true,
                },
              }),
              _vm._v(" "),
              _vm.discount
                ? _c(
                    "div",
                    {
                      staticClass:
                        "lpu-set-card__discount d-inline-flex align-center py-1 px-2 rounded bg-success success--text text-caption",
                      attrs: { "data-qa": "analyses_lpu_set_card_discount" },
                    },
                    [
                      _vm._v(
                        "\n        Скидка " + _vm._s(_vm.discount) + "%\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lpu-set-card__main text-center text-sm-left" },
        [
          _c(
            "div",
            {
              staticClass:
                "lpu-set-card__head lpu-set-card__order-head d-flex flex-column align-center align-sm-start ga-1 min-w-0 w-100",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-center justify-center justify-sm-start gc-2",
                },
                [
                  _c(
                    VIcon,
                    {
                      staticClass: "flex-shrink-0",
                      attrs: { color: "primary", size: "20" },
                    },
                    [_vm._v("\n          ui-icon-hospital-40\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "text-subtitle-2 text--text",
                      attrs: { "data-qa": "analyses_lpu_set_card_type" },
                    },
                    [_vm._v("\n          Сеть лабораторий\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "lpu-set-card__name text-h6" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "text--text text-decoration-none",
                      attrs: {
                        "data-qa": "analyses_lpu_set_card_name",
                        href: _vm.href,
                      },
                    },
                    [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.allLpusHasLicense
                    ? _c(_setup.LpuLicenseBadge, {
                        attrs: {
                          qa: "analyses_lpu_set_card_verified_badge",
                          text: "Лицензии всех филиалов проверены",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "lpu-set-card__details lpu-set-card__order-details d-flex flex-column align-start ga-3 min-w-0 w-100 text-left",
            },
            [
              _c("div", { staticClass: "d-flex align-center gc-2" }, [
                _c("span", {
                  staticClass:
                    "ui-icon-laba ui-icon-fz-medium icon-secondary--text flex-shrink-0",
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "text-body-2 text--text",
                    attrs: {
                      "data-qa": "analyses_lpu_set_card_analyses_count",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.analysesCountText) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-none align-center gc-2" }, [
                _c("span", {
                  staticClass:
                    "ui-icon-clinic ui-icon-fz-medium primary--text flex-shrink-0",
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "text-body-2 primary--text text-decoration-none",
                    attrs: {
                      "data-qa": "analyses_lpu_set_card_branches_link",
                      href: _vm.branchesHref,
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.branchesCountText) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "lpu-set-card__order-btn lpu-set-card__order-cta d-inline-flex align-center justify-center gc-2 py-3 px-4 rounded text-decoration-none w-100 w-sm-auto primary bg-gray-0--text",
              attrs: {
                "data-qa": "analyses_lpu_set_card_order_btn",
                href: _vm.orderHref,
              },
            },
            [
              _c(
                VIcon,
                {
                  staticClass: "flex-shrink-0",
                  attrs: { color: "white", size: "22" },
                },
                [_vm._v("\n        ui-icon-card\n      ")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "text-button" }, [
                _vm._v("\n        Заказать онлайн\n      "),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }